module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.0-73.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.0.md
// module id = 491
// module chunks = 374